export const initialArticlesState = {
  articles: [],
  allArticles: [],
  allArticlesById: {},
  allArticlesByCode: {},
  articlesForGestiune: [],
  articlesForGestiunePage: 0,
  articlesForGestiuneSearch: '',
  articlesForGestiunePageSize: 20,
  articlesForGestiuneLoading: false,

  articlesPaginated: [],
  articlesPaginatedPage: 0,
  articlesPaginatedSearch: '',
  articlesPaginatedPageSize: 20,
  articlesPaginatedLoading: false,

  articlesForGestiuneConsumabile: [],
  articlesForGestiuneConsumabilePage: 0,
  articlesForGestiuneConsumabileSearch: '',
  articlesForGestiuneConsumabilePageSize: 20,
  articlesForGestiuneConsumabileLoading: false,
  articlesWithGestiune: [],
  articlesWithGestiunePage: 0,
  articlesWithGestiuneSearch: '',
  articlesWithGestiunePageSize: 20,
  articlesWithGestiuneLoading: false,
  onlySecondHand: false,
};

export interface IArticlesState {
  articles: any[],
  allArticles: any[],
  allArticlesById: {},
  allArticlesByCode: {},
  articlesForGestiune: any[],
  articlesForGestiunePage: number,
  articlesForGestiuneSearch: string,
  articlesForGestiunePageSize: number,
  articlesForGestiuneLoading: boolean,

  articlesPaginated: any[],
  articlesPaginatedPage: number,
  articlesPaginatedSearch: string,
  articlesPaginatedPageSize: number,
  articlesPaginatedLoading: boolean,

  articlesWithGestiune: any[],
  articlesWithGestiunePage: number,
  articlesWithGestiuneSearch: string,
  articlesWithGestiunePageSize: number,
  articlesWithGestiuneLoading: boolean,
  onlySecondHand: boolean,

  articlesForGestiuneConsumabile: any[],
  articlesForGestiuneConsumabilePage: number,
  articlesForGestiuneConsumabileSearch: string,
  articlesForGestiuneConsumabilePageSize: number,
  articlesForGestiuneConsumabileLoading: boolean,
}
